import Container from 'components/Container';
import { PlayerName } from 'components/Teams/PlayerName';
import { TeamTitle } from 'components/Teams/TeamTitle';
import React, { useMemo } from 'react';
import useStores from 'stores/helpers/useStores';
import styled from 'styled-components';
import { ITeam } from 'types/Team';

const StyledContainer = styled(Container)`
  display: flex;
`;

const TeamsHeader = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
  border-bottom: 1px solid ${(props) => props.theme.palette.dark[50]};
`;

const TeamsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`;

const TeamList = styled.div`
  padding: 12px 0;
  flex: 1;
  border-right: 1px solid ${(props) => props.theme.palette.dark[50]};
  display: flex;
  flex-direction: column;

  &:last-child {
    border-right: 0;
  }

  &:not(:first-child) > div {
    padding-left: 24px;
  }
`;

interface ITeamsListProps {
  teams: ITeam[];
}

const TeamsList: React.FC<ITeamsListProps> = ({ teams }) => {
  const { authStore } = useStores();

  const [winners, rest] = useMemo(() => {
    const win = teams.find((t) => t.won === true);
    return [win, teams.filter((t) => t.id !== win?.id)];
  }, [teams]);

  return (
    <>
      <TeamsHeader>
        <StyledContainer>
          {winners && <TeamTitle team={winners} title="Winners" />}

          {rest.map((team, index) => (
            <TeamTitle
              key={team.id}
              team={team}
              title={winners ? 'Losers' : `Team ${index + 1}`}
            />
          ))}
        </StyledContainer>
      </TeamsHeader>

      <TeamsWrapper>
        <StyledContainer>
          {winners && (
            <TeamList>
              {winners.players.map((player) => (
                <PlayerName
                  key={player.id}
                  player={player}
                  isCurrentPlayer={authStore.profile?.playerId === player.id}
                />
              ))}
            </TeamList>
          )}

          {rest.map((team) => (
            <TeamList key={team.id}>
              {team.players.map((player) => (
                <PlayerName
                  key={player.id}
                  player={player}
                  isCurrentPlayer={authStore.profile?.playerId === player.id}
                />
              ))}
            </TeamList>
          ))}
        </StyledContainer>
      </TeamsWrapper>
    </>
  );
};

export default TeamsList;
